/* import __COLOCATED_TEMPLATE__ from './blade-transaction-recognition-banner.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { TransactionAuthState } from '@square/dashboard-protos/models/squareup/transaction/transaction_service';
let BladeTransactionRecognitionBanner = (_class = class BladeTransactionRecognitionBanner extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  get description() {
    switch (this.args.transactionAuthState) {
      case TransactionAuthState.TRANSACTION_AUTH_RESPONSE_UNSPECIFIED:
        return this.intl.t('banking.checking.unifiedActivity.activityDetails.transactionRecognition.description.initial');
      case TransactionAuthState.TRANSACTION_AUTH_RESPONSE_TRANSACTION_RECOGNIZED:
        return this.intl.t('banking.checking.unifiedActivity.activityDetails.transactionRecognition.description.recognized');
      case TransactionAuthState.TRANSACTION_AUTH_RESPONSE_TRANSACTION_NOT_RECOGNIZED:
        return this.intl.t('banking.checking.unifiedActivity.activityDetails.transactionRecognition.description.notRecognized', {
          link: `/dashboard/transfer/square-card?unitToken=${this.args.unitToken}`,
          htmlSafe: true
        });
      default:
        return null;
    }
  }
  get boldDescription() {
    return this.isUnspecified() ? this.intl.t('banking.checking.unifiedActivity.activityDetails.transactionRecognition.description.boldText') : null;
  }
  get variant() {
    return this.args.transactionAuthState === TransactionAuthState.TRANSACTION_AUTH_RESPONSE_TRANSACTION_RECOGNIZED ? 'info' : 'critical';
  }
  get showButton() {
    return this.isUnspecified();
  }
  recognize() {
    this.args.onRecognizeTransaction(true);
  }
  deny() {
    this.args.onRecognizeTransaction(false);
  }
  isUnspecified() {
    return this.args.transactionAuthState === TransactionAuthState.TRANSACTION_AUTH_RESPONSE_UNSPECIFIED;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "recognize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "recognize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deny", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deny"), _class.prototype)), _class);
export { BladeTransactionRecognitionBanner as default };